import { createContext, ReactNode, useContext } from 'react';

import { HeaderSettings } from '../views/AppContainer/AppContainer';

interface AppContainerContextProps {
  setHeaderVisible: (value: boolean) => void;
  setBottomBarVisible: (value: boolean) => void;
  headerTitle?: string | ReactNode;
  setHeaderTitle: (value: string | ReactNode) => void;
  actualVDPVehicle?: any;
  setActualVDPVehicle: (value: any) => void;
  isFooterVisible: boolean;
  setIsFooterVisible: (value: boolean) => void;
  isDrawerVisible: boolean;
  setDrawerVisible: (value: boolean) => void;
  isDrawerExpanded: boolean;
  setDrawerExpanded: (isOpen: boolean) => void;
  headerRightView?: ReactNode;
  setHeaderRightView: (value: ReactNode) => void;
  headerSettings?: HeaderSettings;
  setHeaderSettings: (value: HeaderSettings) => void;
}

export const AppContainerContext = createContext(undefined as any);

export const useAppContainerContext: () => AppContainerContextProps = () => {
  return useContext(AppContainerContext);
};
